import React, {Fragment, useContext, useEffect, useState} from 'react';
import EquipmentService from './EquipmentService';
import farmerContext from "../../../context/farmer/farmerContext";

const EquipmentServiceScreen = () => {

    const FarmerContext = useContext(farmerContext);
    const [show, setShow] = useState(false);

    const { getEquipmentServices, farmer } = FarmerContext;

    useEffect(() => {
        getEquipmentServices()
        //eslint-disable-next-line
    }, []);
    return (
        <Fragment>
            <div className="content-wrapper">
                <div className="container-fluid">
                    <EquipmentService />
                </div>
            </div>
        </Fragment>
    )
}

export default EquipmentServiceScreen